/// <amd-module name="Test/TestPlansHubRefresh/TestPlansSegment/Redux/TestPlansSegmentContracts" />
import { ITestHubRefreshAwareState } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";
import { Favorite } from "Favorites/Common/Contracts/Favorite";

export interface ITestPlansSegmentAwareState extends ITestHubRefreshAwareState {
    testPlansSegmentState: ITestPlansSegmentState;
}

export interface ITestPlansSegmentState {
    isFavorited: boolean;
    favoriteId: string;
    favoritePlans: Favorite[];
    testPlanProgressSummary: string;
}
